// Needs to remain global permanently
// It's used in JSPs and DB faqs
window.g_openWindow = function (page, height, width, win, scrollbars, resizable, toolbar, menubar, left, top) {
    if (!height) { height = 400; }
    if (!width) { width = 560; }
    if (!win) { win = '_new'; }
    const w = 'WIDTH=' + width.toString();
    const h = 'HEIGHT=' + height.toString();
    const scrol = ',scrollbars=' + ((scrollbars) ? 'yes' : 'no');
    const siz = ',resizable=' + ((resizable) ? 'yes' : 'no');
    const tool = ',toolbar=' + ((toolbar) ? 'yes' : 'no');
    const menu = ',menubar=' + ((menubar) ? 'yes' : 'no');
    let attr = w + ',' + h + scrol + siz + tool + menu;
    if (left) { attr = attr + ',left=' + left; }
    if (top) { attr = attr + ',top=' + top; }

    const popupWin = window.open(page, win, attr);
    popupWin.focus();
    return popupWin;
};
